export const SESSION_MODES = Object.freeze({
  online: 'online',
  offline: 'offline',
  homeVisit: 'home-visit',
})

export const FLOW_TYPES = Object.freeze({
  publicLiveSession: 'public-live-session',
  consumerLiveSession: 'consumer-live-session',
  mentorLiveSession: 'mentor-live-session',
  mentorChamberAutoJoin: 'mentor-chamber-auto-join',
  chamberScreen: 'chamber-screen',
  kioskScreen: 'kiosk-screen',
  auditSession: 'audit-session',
})

export const RTC_PROVIDERS = Object.freeze({
  agora: 'agora',
  hundredMs: '100ms',
  futureProvider: 'future-provider',
})

export const SIGNALING_PROVIDERS = Object.freeze({
  agoraRtm: 'agora-rtm',
  internalSignal: 'internal-signal',
})

export const CHAT_PROVIDERS = Object.freeze({
  agoraChat: 'agora-chat',
  internalChat: 'internal-chat',
})

export const RECORDING_PROVIDERS = Object.freeze({
  agoraCloud: 'agora-cloud',
  hundredMsRecording: '100ms-recording',
  mediaPipeline: 'media-pipeline',
})

export const TRANSCRIPTION_PROVIDERS = Object.freeze({
  none: 'none',
  providerNative: 'provider-native',
  externalStt: 'external-stt',
})
